import React from "react";
import QRCode from 'react-qr-code';
import Barcode from "react-barcode";

const CreatePDF = React.forwardRef(({ vehicleTagNumber }, ref) => (
    <div ref={ref} style={{ pageBreakBefore: "always", marginTop: "100px" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img 
                src="/static/cargills-agri-logo01.png" 
                alt="Cargills Logo" 
                style={{ maxWidth: "300px", marginBottom: "20px" }}
            />
            <div style={{ 
                marginTop: 20, 
                width: "470px", 
                display: "flex", 
                justifyContent: "center" 
            }}>
                <QRCode value={vehicleTagNumber || ""} size={470} />
            </div>
            <div style={{ 
                marginTop: 20, 
                width: "470px", 
                display: "flex", 
                justifyContent: "center" 
            }}>
                <Barcode 
                    value={vehicleTagNumber || ""} 
                    width={3} 
                    height={160} 
                    fontOptions="bold" 
                    displayValue={false} 
                    margin={0} 
                />
            </div>
            <div style={{ 
                marginTop: 20, 
                fontSize: 37, 
                fontWeight: "bold", 
                width: "100%", 
                wordWrap: "break-word", 
                textAlign: "center", 
                fontFamily: "'DIN Condensed', 'Arial Narrow', sans-serif", 
                letterSpacing: "4px" 
            }}>
                {vehicleTagNumber || ""}
            </div>
        </div>
    </div>
));


CreatePDF.displayName = 'CreatePDF';

export default CreatePDF;
